import React from 'react'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { ChapterPromotionAcceptProps, ChapterPromotionProps } from './interface'

export function withBookPromotion(Component: React.FC<ChapterPromotionProps>) {
  function WithBookPromotion({ isDrawer = false }: ChapterPromotionAcceptProps) {
    const { data } = useStoryReader()
    const newProps = {
      data: data?.bookChapterCampaignHeader,
      isDrawer,
    }

    return <Component {...newProps} />
  }

  return WithBookPromotion
}
